import { render, staticRenderFns } from "./ShareFrame.vue?vue&type=template&id=38237c44"
import script from "./ShareFrame.vue?vue&type=script&lang=js"
export * from "./ShareFrame.vue?vue&type=script&lang=js"
import style0 from "./ShareFrame.vue?vue&type=style&index=0&id=38237c44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports